<!--
    课程统计-授权统计-授权账号数详情
    功能：展示当前数据授权账号数，操作取消授权
    说明：版本3.0
-->
<template>
  <el-dialog
    :visible.sync="visible"
    :before-close="handleClose"
    :title="curRow.auth_status == 1?'授权账号数详情':'取消账号数详情'"
    :close-on-click-modal="false"
    width="600px"
  >
    <div
      v-if="curRow.auth_status == 1"
      class="btns">
      <el-button
        :loading="submitLoading"
        size="medium"
        type="primary"
        @click="handlerCloseAuth">
        取消授权({{ selList.length }})
      </el-button>
    </div>
    <el-table
      v-loading="isLoading"
      ref="multipleTable"
      :data="tableData"
      row-key="search_staff_mobile"
      fit
      highlight-current-row
      style="width: 100%;"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="curRow.auth_status == 1"
        :reserve-selection="true"
        :selectable="checkSelectable"
        type="selection"
        width="55"
        align="center"
      />
      <el-table-column
        v-for="(item,index) in tableHead"
        :key="index"
        :label="item.label"
        :prop="item.prop"
        :width="item.width"
        :formatter="item.formatter"
      />
    </el-table>
  </el-dialog>
</template>
<script>
import { closeAuthPacket } from '@/api/courseStatistics';

export default {
  name: 'DialogDelete',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    curRow: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      tableHead: [{
        prop: 'to_users_name',
        label: '用户名称',
      }, {
        prop: 'to_users_phone',
        label: '用户手机号',
      },
      {
        label: '授权状态',
        formatter: (row) => {
          const type = {
            1: '已授权',
            2: '取消授权',
          };
          return type[row.auth_status];
        },
      }],
      isLoading: false,
      selList: [],
      tableData: [],
      submitLoading: false,
    };
  },
  mounted() {
    const newArr = [];
    this.curRow.users.forEach((item) => {
      // if (item.auth_status === this.curRow.auth_status) {
      //   newArr.push(item);
      // }
      newArr.push(item);
    });
    this.tableData = newArr;
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    handleSelectionChange(v) {
      this.selList = v;
    },
    handlerCloseAuth() {
      if (this.selList.length) {
        const auth_record_user_list = [];
        this.selList.forEach((item) => {
          auth_record_user_list.push({
            id: item.id,
          });
        });
        const obj = {
          auth_record_id: this.curRow.id,
          auth_record_user_list,
        };
        this.submitLoading = true;
        closeAuthPacket(this.curRow.auth_type, this.$store.state.choicesSchool.id, obj).then((res) => {
          if (res.status_code === 200) {
            this.$message.success('操作成功！');
            this.$emit('update:visible', false);
            this.$emit('refresh');
          } else {
            this.$message.error(res.message);
          }
        }).finally(() => {
          this.submitLoading = false;
        });
      } else {
        this.$message.warning('请选择用户');
      }
    },
    checkSelectable(row) {
      return row.auth_status === 1;
    },
  },
};
</script>
<style lang="scss" scoped>
.btns{
  text-align: right;
  padding-bottom: 20px;
}
</style>




// WEBPACK FOOTER //
// src/views/CourseStatistics/AuthorityStatistics/usersInfoDialog.vue